document.addEventListener("DOMContentLoaded", function () {
	/**
	 * Configurazione universale per la gestione di più Swiper
	 * Supporta tutti i tipi di caroselli con controlli contestualizzati
	 */

	// Configurazioni per ogni tipo di swiper
	const swiperConfigs = {
		servizi: {
			selector: ".swiper-servizi",
			config: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
			},
		},
		"idee-regalo": {
			selector: ".swiper-idee-regalo",
			config: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 12,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 12,
					},
				},
			},
		},
		galleria: {
			selector: ".swiper-galleria",
			config: {
				slidesPerView: 1.2,
				slidesPerGroup: 1,
				spaceBetween: 12,
				breakpoints: {
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 16,
					},
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 24,
					},
				},
			},
		},
		"testo-galleria": {
			selector: ".swiper-testo-galleria",
			config: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
				// Carosello semplice con 1 slide alla volta
			},
		},
		news: {
			selector: ".swiper-news",
			config: {
				slidesPerView: 1.2,
				slidesPerGroup: 1,
				spaceBetween: 12,
				breakpoints: {
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 16,
					},
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 24,
					},
				},
			},
		},
		prodotti: {
			selector: ".swiper-prodotti",
			config: {
				slidesPerView: 1.2,
				spaceBetween: 12,
				breakpoints: {
					576: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
				},
			},
		},
	};

	/**
	 * Funzioni di utility per gestire i controlli Swiper
	 */
	function updateSwiperProgress(swiperContainer, swiper) {
		const scrollbarDrag = swiperContainer.querySelector(".swiper-scrollbar-drag");
		const slidesPerGroup = swiper.params.slidesPerGroup || 1;
		const totalSlides = swiper.slides.length;
		const totalGroups = Math.ceil(totalSlides / slidesPerGroup);
		let currentGroupIndex = Math.ceil((swiper.realIndex + 1) / slidesPerGroup);
		const groupProgress = (currentGroupIndex / totalGroups) * 100;

		if (scrollbarDrag) {
			scrollbarDrag.style.width = `${groupProgress}%`;
		}

		return { currentGroupIndex, totalGroups };
	}

	function updateSwiperIndex(swiperContainer, swiper) {
		const { currentGroupIndex } = updateSwiperProgress(swiperContainer, swiper);
		const indexElement = swiperContainer.querySelector(".swiper-pagination-index");

		if (indexElement) {
			const formattedIndex = currentGroupIndex < 10 ? "0" + currentGroupIndex : currentGroupIndex;
			indexElement.textContent = formattedIndex;
		}
	}

	function handleSwiperSlideChange(swiperContainer, swiper) {
		const slidesPerView = swiper.params.slidesPerView || 1;
		const slidesPerGroup = swiper.params.slidesPerGroup || 1;
		const totalSlides = swiper.slides.length;
		const totalGroups = Math.ceil(totalSlides / slidesPerGroup);
		let currentGroupIndex = Math.ceil((swiper.realIndex + 1) / slidesPerGroup);

		// Correggi l'indice per l'ultima slide
		if (swiper.realIndex + slidesPerView >= totalSlides) {
			currentGroupIndex = totalGroups;
		}

		updateSwiperIndex(swiperContainer, swiper);
		updateSwiperProgress(swiperContainer, swiper);
	}

	/**
	 * Inizializza tutti i tipi di Swiper
	 */
	Object.entries(swiperConfigs).forEach(([type, swiperData]) => {
		// Trova tutti gli elementi con questa classe (supporta più istanze)
		const swiperElements = document.querySelectorAll(swiperData.selector);

		swiperElements.forEach((swiperElement, index) => {
			const swiperControls = swiperElement.querySelector(".swiper-controls");

			// Verticalizzazione per i caroselli di tipo "prodotti"
			if (type === "prodotti") {
				const slidesCount = parseInt(swiperElement.dataset.slidesCount, 10) || 0;
				console.log(`Prodotti swiper #${index + 1} ha ${slidesCount} slides.`, swiperData);

				if (slidesCount === 1) {
					swiperData.config.slidesPerView = 1;
					swiperData.config.spaceBetween = 0;
				} else if (slidesCount === 2) {
					swiperData.config.slidesPerView = 1.2;
					swiperData.config.spaceBetween = 16;
					delete swiperData.config.breakpoints[992];
				}
				console.log("Configurazione aggiornata per prodotti swiper:", swiperData.config);
			}

			// Configurazione base con controlli contestualizzati
			const config = {
				...swiperData.config,
				navigation: {
					nextEl: swiperElement.querySelector(".swiper-button-next"),
					prevEl: swiperElement.querySelector(".swiper-button-prev"),
				},
				on: {
					init: function (swiper) {
						if (swiperControls && swiper.isLocked) {
							swiperControls.classList.add("d-none");
						}
						updateSwiperIndex(swiperElement, swiper);
						updateSwiperProgress(swiperElement, swiper);
					},
					lock: function () {
						if (swiperControls) {
							swiperControls.classList.add("d-none");
						}
					},
					unlock: function () {
						if (swiperControls) {
							swiperControls.classList.remove("d-none");
						}
					},
					slideChange: function (swiper) {
						handleSwiperSlideChange(swiperElement, swiper);
					},
				},
			};

			// Inizializza il swiper con un ID univoco
			const swiperInstance = new Swiper(swiperElement, config);

			// Console log per debug (opzionale)
			console.log(`Inizializzato ${type} swiper #${index + 1}:`, swiperInstance);
		});
	});
});
